<template>
  <div class="page-container">
    <h1 class="page-title">{{ getNewsData.title }}</h1>
    <p style="text-align: right;">{{ getNewsData.date }}</p>
    <div class="content">
      <!-- 第一段内容：MT29会议介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(getNewsData.content?.split('---')[0] || '')"></p>
        </div>
      </div>
      
      <!-- 第一张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture1?.url" :alt="getNewsData.other?.picture1?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture1?.caption">{{ getNewsData.other?.picture1?.caption }}</p>
        </div>
      </div>
      
      <!-- 第二段内容：上海超导参展报告 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(getNewsData.content?.split('---')[1] || '')"></p>
        </div>
      </div>
      
      <!-- 第二张图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture2?.url" :alt="getNewsData.other?.picture2?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture2?.caption">{{ getNewsData.other?.picture2?.caption }}</p>
        </div>
      </div>
      
      <!-- 第三段内容：回顾2025上半年 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(getNewsData.content?.split('---')[2] || '')"></p>
        </div>
        <div class="text-block">
          <p v-html="highlightText(getNewsData.content?.split('---')[3] || '')"></p>
        </div>
        <div class="text-block" style="margin-top: 30px;">
          <p v-html="highlightText(getNewsData.content?.split('---')[4] || '')"></p>
        </div>
        
      </div>
      
      <!-- 01标题和内容 -->
      <div class="content-section">
        <div class="text-block">
          <h3 v-html="highlightText(getNewsData.content?.split('---')[5] || '')"></h3>
          <p v-html="highlightText(getNewsData.content?.split('---')[6] || '')"></p>
        </div>
      </div>
      
      <!-- 01活动图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture3?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture3?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
      
              <!-- 02活动承办内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(getNewsData.content?.split('---')[7] || '')"></p>
          </div>
        </div>

        <div class="content-section">
        <div class="text-block">
          <h3 v-html="highlightText(getNewsData.content?.split('---')[8] || '')"></h3>
          <p v-html="highlightText(getNewsData.content?.split('---')[9] || '')"></p>
        </div>
      </div>
      
      <!-- 02活动图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture4?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture4?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
      
              <!-- 02活动承办内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(getNewsData.content?.split('---')[10] || '')"></p>
          </div>
        </div>
    
      

        <div class="content-section">
        <div class="text-block">
          <h3 v-html="highlightText(getNewsData.content?.split('---')[11] || '')"></h3>
          <p v-html="highlightText(getNewsData.content?.split('---')[12] || '')"></p>
        </div>
      </div>
      
      <!-- 02活动图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture5?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture5?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
      
              <!-- 02活动承办内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(getNewsData.content?.split('---')[13] || '')"></p>
          </div>
        </div>
        <div class="content-section">
        <div class="text-block">
          <h3 v-html="highlightText(getNewsData.content?.split('---')[14] || '')"></h3>
          <p v-html="highlightText(getNewsData.content?.split('---')[15] || '')"></p>
        </div>
      </div>
      
      <!-- 02活动图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture6?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture6?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
      
              <!-- 02活动承办内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(getNewsData.content?.split('---')[16] || '')"></p>
          </div>
        </div>
        <div class="content-section">
        <div class="text-block">
          <h3 v-html="highlightText(getNewsData.content?.split('---')[17] || '')"></h3>
          <p v-html="highlightText(getNewsData.content?.split('---')[18] || '')"></p>
        </div>
      </div>
      
      <!-- 02活动图片 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture7?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture7?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="getNewsData.other?.picture8?.url" :alt="getNewsData.other?.picture3?.caption">
          <p class="image-caption" v-if="getNewsData.other?.picture8?.caption">{{ getNewsData.other?.picture3?.caption }}</p>
        </div>
      </div>
              <!-- 02活动承办内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(getNewsData.content?.split('---')[19] || '')"></p>
            <p v-html="highlightText(getNewsData.content?.split('---')[20] || '')"></p>

          </div>
        </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const getNewsData = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 查找URL匹配的新闻
  const newsItem = newsList.find((item: any) => item.url === '/news/mt29huiyi');
  return newsItem || {};
});

// 高亮处理函数
const highlightText = (text: string) => {
  if (!text) return '';
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlight">$1</span>');
};

</script>

<style scoped lang="scss">
@import "@/assets/styles/content-blocks.scss";

/* 页面特定样式 */
.page-container{
  overflow: auto; 
}

.content-section {
  margin-bottom: 30px;
}

.image-section {
  text-align: center;
  
  .image-container {
    display: inline-block;
    max-width: 100%;
    margin: 0 10px;
    
    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
  
  .image-grid {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    
    .image-container {
      flex: 1;
      max-width: 45%;
      min-width: 300px;
    }
  }
}

.text-block {
  p {
    text-align: justify;
    line-height: 1.8;
    margin-bottom: 16px;
  }
  
  h3 {
    color: #333;
    margin-bottom: 12px;
    font-weight: 600;
  }
  :deep(.highlight) {
    font-weight: bold;
    color: #1a56db;
  }
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  text-align: center;
  font-style: italic;
}

/* 高亮文本样式 */
:deep(.highlighted-text) {
  background-color: #fff3cd;
  color: #856404;
  padding: 2px 4px;
  border-radius: 3px;
  font-weight: 600;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .image-grid {
    flex-direction: column;
    
    .image-container {
      max-width: 100%;
      min-width: auto;
    }
  }
}
</style> 